module.exports = __webpack_public_path__ + "img/franciliens.net.png";